import { EventBus } from '@/helpers/eventBus'
import { createNamespacedHelpers, mapActions } from 'vuex'
import platformTranslator from '@/helpers/platformTranslator'
import Select from '@/components/Select.vue'
import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')
const platformController = createNamespacedHelpers('platform')

export default {
  data () {
    return {
      loading: false,
      sliceEnd: 3
    }
  },
  components: {
    'k-select': Select
  },
  mixins: [platformTranslator],
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    block_id: {
      type: Number,
      default: 0
    },
    Template_Attributes: {
      type: Array,
      default: function () {
        return []
      }
    },
    Template_Connectors: {
      type: Array,
      default: function () {
        return []
      }
    },
    Elements: {
      type: Array,
      default: function () {
        return []
      }
    },
    Platforms: {
      type: Array,
      default: function () {
        return []
      }
    },
    isLast: {
      type: Boolean,
      default: true
    },
    template_id: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale', 'selectedLanguageName']),
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    parsedPlatforms () {
      return this.platforms.map(p => {
        return {
          label: p.title,
          id: p.platform_id
        }
      })
    },
    selected_platforms () {
      return this.Platforms.map(p => p.platform_id)
    },
    selectedPlatformsObjects () {
      return this.Platforms.filter(p => this.selected_platforms.includes(p.platform_id))
    }
  },
  methods: {
    ...mapActions(['template/update', 'template_attribute/create', 'template_attribute/update', 'element/create', 'element/update', 'element/destroy', 'template_connector/create', 'template_connector/destroy', 'template/basicUpdate', 'template/addPlatform', 'template/removePlatform','element_attribute/update']),
    parseBoolean (value) {
      return value != undefined ? (value == 1 || value == '1' || value == true || value == 'true') : false
    },
    repaintBlock () {
      EventBus.$emit('jsplumb:repaint', `block_${this.block_id}`)
    },
    generateNumberOptions (limit, min = 1) {
      let array = []
      for (let i = min; i <= limit; i++) {
        array.push({
          label: i,
          id: i
        })
      }

      return array
    },
    getAttribute (attribute_name) {
      let attribute = this.Template_Attributes.find(template_attribute => template_attribute.name == attribute_name)
      return attribute
    },
    updateTemplate (block_id, template_id, template) {
      let self = this
      console.log("UPDATE TEMPLATE")
      this.$Progress.start()

      this['template/update']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        ...template,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.updateTemplate.apply(this, arguments)
            }
          }
        }
      })
    },
    updateTemplateBasic (blockId, templateId, template) {
      const self = this
      this.$Progress.start()

      this['template/basicUpdate']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: blockId,
        template_id: templateId,
        ...template,
        callback: async (res) => {
          this.$Progress.finish()

          if (res.error) {
            const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res === true) this.updateTemplateBasic.apply(this, arguments)
          }
        }
      })
    },
    createAttribute (block_id, template_id, template_attribute) {
      let self = this
      this.loading = true
      this.$Progress.start()
      this['template_attribute/create']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        ...template_attribute,
        callback: async (res) => {
          self.loading = false
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) {
              this.createAttribute.apply(this, arguments)
            }
          } else {
            this.Template_Attributes.push(res.resource)
          }
        }
      })
    },
    updateAttribute (blockId, templateId, templateAttribute) {
      return new Promise(resolve => {
        const self = this
        this.loading = true

        this.$Progress.start()

        this['template_attribute/update']({
          account_id: self.$route.params.account_id,
          language_id: self.selectedLanguage,
          block_id: blockId,
          template_id: templateId,
          ...templateAttribute,
          callback: async (res) => {
            self.loading = false
            this.$Progress.finish()

            resolve()

            if (res.error) {
              const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando template. ¿Deseas intentarlo de nuevo?', {
                title: 'Error de guardado',
                okVariant: 'primary',
                okTitle: 'Reintentar',
                cancelTitle: 'Cancelar',
                cancelVariant: 'secondary',
                hideHeaderClose: false
              })

              if (res === true) this.updateAttribute.apply(this, arguments)
            }
          }
        })
      })
    },
    createConnector (block_id, template_id, connector) {
      let self = this
      this.$Progress.start()
      this['template_connector/create']({
        language_id: self.selectedLanguage,
        template_id: template_id,
        block_id: block_id,
        ...connector,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.createConnector.apply(this, arguments)
            }
          }
        }
      })
    },
    deleteConnector (block_id, template_id, connector) {
      let self = this
      this.$Progress.start()
      this['template_connector/destroy']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        ...connector,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error eliminando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de borrado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res === true) return this.deleteConnector(...arguments)
          }

          console.log(connector)
        }
      })
    },
    createElement (block_id, template_id, element) {
      let self = this
      this.$Progress.start()
      this['element/create']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        ...element,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando elemento. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.createElement.apply(this, arguments)
            }
          }
        }
      })
    },
    updateElement (block_id, template_id, element) {
      let self = this
      this.$Progress.start()
      this['element/update']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        ...element,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando elemento. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.updateElement.apply(this, arguments)
            }
          }
        }
      })
    },
    destroyElement (block_id, template_id, element) {
      let self = this
      this.$Progress.start()
      this['element/destroy']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        ...element,
        callback: async (res) => {
          this.$Progress.finish()
          if (!res.error || res.error === 'Element not found') return
            let answer = await this.$bvModal.msgBoxConfirm('Ocurrió un error eliminando elemento. ¿Deseas intentarlo de nuevo?', {
              title: 'Error eliminando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (answer == true) {
              this.destroyElement.apply(this, arguments)
            }
        }
      })
    },
    addPlatform (block_id, template_id, platform_id) {
      let self = this
      this.$Progress.start()
      this['template/addPlatform']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        platform_id: platform_id,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando plataforma. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.addPlatform.apply(this, arguments)
            }
          }
        }
      })
    },
    removePlatform (block_id, template_id, platform_id) {
      let self = this
      this.$Progress.start()
      this['template/removePlatform']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: block_id,
        template_id: template_id,
        platform_id: platform_id,
        callback: async (res) => {
          this.$Progress.finish()
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error quitando plataforma. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de borrado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res == true) {
              this.removePlatform.apply(this, arguments)
            }
          }
        }
      })
    },
    isJson (event) {
      let {value} = event.target
      if(!value || value.includes('{{')) return
      try {
        JSON.parse(value);
      } catch (e) {
        this.$message.warning('Error en formato JSON.')
        this.$nextTick(() => {
          this.$message.warning(e.toString())
        })
      }
    },
  },
  created () {
    this.updatePlatforms = _debounce((platforms) => {
      if (this.selected_platforms.length > platforms.length) {
        let changed = this.selected_platforms.diff(platforms)
        for (let platform_id of changed) {
          this.removePlatform(this.block_id, this.template_id, platform_id)
        }
      } else {
        let changed = platforms.diff(this.selected_platforms)
        for (let platform_id of changed) {
          this.addPlatform(this.block_id, this.template_id, platform_id)
        }
      }
    }, 500, { leading: true, trailing: true })
  }
}
